export const DEFAULT_JIRA_ISSUE_EMBEDDED_CONF_SOURCE = 'jiraIssueView';
export const JIRA_ISSUE_LINKED_MENTIONED_PAGES = 'jiraIssueViewLinkedMentionedPage';
export const JIRA_ISSUE_QUICK_ACTIONS = 'jiraIssueViewQuickAddItem';
export const JIRA_ISSUE_LINK_PAGE = 'jiraIssueViewLinkConfluencePage';
export const JIRA_ISSUE_LENGTHY_DESCRIPTION_PROMPT = 'jiraIssueViewLengthyDescriptionMessage';
export const JIRA_SOFTWARE_BACKLOG_END_OF_SPRINT_RETRO = 'jiraSoftwareBacklogEndOfSprintRetro';
